import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
// import moment from "moment";
import styled from "styled-components";
import { find, isEmpty } from "lodash";

import {
  comboBox,
  SLBTxtBox,
  SLBTextarea,
  SLBSelect,
  SLBDateTimePicker
} from "../utils/Forms";

const READING_DELIMETER = ":::";
const SUNDAY_SERVICE = "sunday_service";
const REGULAR = "regular";

const AssetImage = styled.img`
  width: 100%;
`;

export default class EventModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      event: {},
      preachers: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.startDateChanged = this.startDateChanged.bind(this);
    this.endDateChanged = this.endDateChanged.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.handleEventTypeChanged = this.handleEventTypeChanged.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setEvent(nextProps.currentEvent);
    this.cacheAssets(nextProps.assets);
  }

  cacheAssets(assets) {
    this.setState({ assets });
  }

  findAsset(id) {
    return find(this.state.assets, asset => asset.id === id);
  }
  setEvent(data = {}) {

    let reading1 = "",
      reading2 = "",
      reading3 = "";

    if (!isEmpty(data.readings)) {
      const readings = data.readings.split(READING_DELIMETER);
      reading1 = readings[0];
      reading2 = readings[1];
      reading3 = readings[2];
    }

    const event = {
      title: data.title || "",
      event_type: data.event_type || REGULAR,
      end_date: data.end_date || null,
      start_date: data.start_date || null,
      reading1: reading1,
      reading2: reading2,
      reading3: reading3,
      description: data.description || "",
      preacher_id: data.preacher_id || 0,
      theme: data.theme || "",
      id: data.id || 0,
      image: "",
      app_asset_id: data.app_asset_id || 0,
      selectedAsset: !!data.app_asset_id
        ? this.findAsset(data.app_asset_id)
        : null
    };

    this.setState({ event });
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (name === "app_asset_id") {
      const asset = this.findAsset(+value);
      let updatedEvent = {
        ...this.state.event,
        selectedAsset: asset,
        app_asset_id: +value
      };
      this.setState({ ...this.state, event: updatedEvent });
    } else {
      let newEvent = { ...this.state.event, [name]: value };
      this.setState({ ...this.state, event: newEvent });
    }
  }

  handleDateChange(field, newDate) {
    let newEvent = { ...this.state.event, [field]: newDate };
    this.setState({ ...this.state, event: newEvent });
  }

  onImageChange(encoded_image) {
    let updatedEvent = { ...this.state.event, image: encoded_image };
    this.setState({ ...this.state, event: updatedEvent });
  }

  startDateChanged(date) {
    this.handleDateChange("start_date", date);
  }

  endDateChanged(date) {
    this.handleDateChange("end_date", date);
  }

  handleEventTypeChanged(eventType) {}

  isEventValid(event = {}) {
    let errors = {};

    const {
      title,
      event_type,
      start_date,
      end_date,
      preacher_id,
      theme
    } = event;

    if (isEmpty(title)) {
      errors["title"] = "Title is required";
    }

    if (isEmpty(start_date)) {
      errors["start_date"] = "Title is required";
    }

    if (isEmpty(end_date)) {
      errors["end_date"] = "Title is required";
    }

    if (event_type === SUNDAY_SERVICE) {
      if (!preacher_id) {
        errors["preacher_id"] = "Preacher is required!";
      }

      if (isEmpty(theme)) {
        errors["theme"] = "Theme is required!";
      }
    }
    this.setState({ errors });
    return isEmpty(errors);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isEventValid(this.state.event)) {
      this.transformReadings(this.state.event);
      this.props.saveEvent(this.state.event);
    }
  }

  transformReadings(data) {
    if (data.event_type === SUNDAY_SERVICE) {
      data.readings = [data.reading1, data.reading2, data.reading3].join(
        READING_DELIMETER
      );
    }
  }

  render() {
    let {
      title,
      event_type,
      id,
      end_date,
      start_date,
      preacher_id,
      theme,
      reading1,
      reading2,
      reading3,
      description,
      app_asset_id,
      selectedAsset
    } = this.state.event;

    const { preachers, assets } = this.props;
    const assetIds = [0].concat(assets.map(x => x.id));
    const assetNames = [""].concat(assets.map(x => x.title));

    const { errors } = this.state;
    let buttonText = id > 0 ? "Update" : "Create";
    const eventTypes = {
      [REGULAR]: "Regular",
      [SUNDAY_SERVICE]: "Sunday Service"
    };

    const eventNames = Object.keys(eventTypes);
    const eventValues = Object.values(eventTypes);

    const preacherValues = [""].concat(preachers.map(preacher => preacher.id));
    const preacherNames = [""].concat(preachers.map(preacher => preacher.name));

    let readingList = [reading1, reading2, reading3].map((reading, index) => {
      let label = `Reading ${index + 1}`;
      let name = `reading${index + 1}`;
      return (
        <SLBTxtBox
          key={index}
          label={label}
          name={name}
          value={reading}
          context={this}
          attrs={{ errors, klass: "col-md-4" }}
        />
      );
    });

    let serviceFields = null;
    if (event_type === SUNDAY_SERVICE) {
      serviceFields = (
        <div>
          <div className="col-md-12">
            <SLBTxtBox
              label="Theme"
              name="theme"
              value={theme}
              context={this}
              attrs={{ errors, klass: "col-md-12" }}
            />
          </div>
          <br /> <br />
          <div className="col-md-12">
            {comboBox(
              "Preacher",
              "preacher_id",
              preacher_id,
              this,
              preacherNames,
              preacherValues,
              { errors, klass: "col-md-12" }
            )}
          </div>
          <br /> <br />
          <div className="col-md-12">{readingList}</div>
        </div>
      );
    }

    return (
      <Modal
        show={this.props.showModal}
        onHide={() => this.props.hideModal()}
        bsSize="large"
      >
        <Modal.Header closeButton>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-8">
                <div className="clearfix">
                  <div className="col-md-12">
                    <SLBTxtBox
                      label="Title"
                      name="title"
                      value={title}
                      context={this}
                      attrs={{ errors, klass: "col-md-12" }}
                    />
                  </div>
                  <div className="col-md-12">
                    {comboBox(
                      "Type of event",
                      "event_type",
                      event_type,
                      this,
                      eventValues,
                      eventNames,
                      { errors, klass: "col-md-12" }
                    )}
                  </div>
                  <div className="col-md-12">
                    <SLBTextarea
                      label="Description"
                      name="description"
                      value={description}
                      context={this}
                      attrs={{ errors, klass: "col-md-12" }}
                    />
                  </div>
                  <br /> <br />
                  {serviceFields}
                  <br /> <br />
                  <div className="col-md-12">
                    <SLBDateTimePicker
                      label="Starts"
                      name="end_date"
                      value={start_date}
                      handleChange={this.startDateChanged}
                      attrs={{ errors, klass: "col-md-6" }}
                    />
                    <SLBDateTimePicker
                      label="Ends at"
                      name="end_date"
                      value={end_date}
                      handleChange={this.endDateChanged}
                      attrs={{ errors, klass: "col-md-6" }}
                    />
                  </div>
                  <br />
                  <div className="col-md-12 edit-buttons-pane">
                    <input
                      className="btn btn-success pull-right"
                      type="submit"
                      value={buttonText}
                    />
                    <a
                      className="btn btn-default pull-right"
                      style={{ marginRight: 10 }}
                      onClick={() => this.props.hideModal()}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="">
                  <SLBSelect
                  label="Image"
                    name="app_asset_id"
                    value={app_asset_id}
                    context={this}
                    values={assetIds}
                    options={assetNames}
                    attrs={{ errors, klass: "col-md-12" }}
                  />
                </div>
                {selectedAsset && <AssetImage src={selectedAsset.item.url} />}
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EventModal.js